import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Services } from "./components/services";
import { About } from "./components/about";
import { Contact } from "./components/contact";

import AdminMessages from "./components/AdminMessages";
import AdminContent from "./components/AdminContent";

import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import CryptoJS from "crypto-js";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

// Landing sayfasını component yapalım
function Landing({ landingPageData }) {
  return (
    <div>
      <Navigation servicesData={landingPageData.Services} />
      <Header data={landingPageData.Header} />
      <Services data={landingPageData.Services} />
      <About data={landingPageData.About} />
      <Contact data={landingPageData.Contact} />
    </div>
  );
}

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    fetch("/api/content")
      .then((r) => {
        if (!r.ok) throw new Error("İçerik alınamadı");
        return r.json();
      })
      .then(({ data }) => {
        const bytes = CryptoJS.AES.decrypt(data, process.env.REACT_APP_CONTENT_SECRET);
        const decrypted = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        setLandingPageData(decrypted);
      })
      .catch(() => setLandingPageData(JsonData));
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {/* Landing */}
        <Route path="/" element={<Landing landingPageData={landingPageData} />} />

        {/* Gizli Admin sayfaları */}
        <Route path="/tomedyus-admin/messages" element={<AdminMessages />} />
        <Route path="/tomedyus-admin/content" element={<AdminContent />} />

        {/* Bilinmeyen path -> ana sayfa */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
